"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useArrowHandling = void 0;
var _react = _interopRequireDefault(require("react"));
var _utils = require("../utils");
const useArrowHandling = (ref, dependencies) => {
  return _react.default.useCallback(event => {
    const elements = [...ref.current.querySelectorAll('li')];
    const focusedItemIndex = elements.findIndex(element => element === document.activeElement);
    if (event.key === 'ArrowDown') {
      (0, _utils.focusNext)(focusedItemIndex, elements);
    }
    if (event.key === 'ArrowUp') {
      (0, _utils.focusPrev)(focusedItemIndex, elements);
    }
  }, [...dependencies]);
};
exports.useArrowHandling = useArrowHandling;
//# sourceMappingURL=arrowHandling.js.map